import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { Container, Grid, Box, Typography } from "@mui/material";

import Input from "@/components/ph/Input";
import Select from "@/components/ph/Select";

import FormSection from "../../utils/FormSection";

import { setFormValue, setValidValue, getAdressData } from "../contractorSlice";

import { useContractorValidation } from '../hooks/useContractorValidation';

const ContractorAdress = () => {
    const dispatch = useDispatch();

    const formValues = useSelector((state) => state.contractor.formValues);
    const coloniasOptions = useSelector((state) => state.contractor.coloniasOptions);
    const driverFormValues = useSelector((state) => state.driver.formValues);

    const handleChange = (e) => {
        const { name, value } = e.target;
        dispatch(setFormValue({ field: name, value }));
    };

    useEffect(() => {
        if (!formValues.codigoPostal && driverFormValues.codigoPostal) {
            dispatch(setFormValue({ field: "codigoPostal", value: driverFormValues.codigoPostal }));
        }
    }, [formValues.codigoPostal, driverFormValues.codigoPostal, dispatch]);

    useEffect(() => {
        if (formValues.codigoPostal) {
            dispatch(getAdressData({ zipCode: formValues.codigoPostal }));
        }
    }, [formValues.codigoPostal, dispatch]);

    const estadoField = useContractorValidation("estadoRepublica", { required: true });
    const municipioField = useContractorValidation("alcaldiaMunicipio", { required: true });
    const coloniaField = useContractorValidation("colonia", { required: true });
    const calleField = useContractorValidation("calle", { required: true });
    const numeroExteriorField = useContractorValidation("numeroExterior", { required: true });
    const numeroInteriorField = useContractorValidation("numeroInterior", { required: false });

    useEffect(() => {
        if (formValues.esMismoDomicilioFiscal === "Si") {
            const fieldsToSync = [
                "codigoPostal",
                "colonia",
                "alcaldiaMunicipio",
                "estadoRepublica",
                "calle",
                "numeroExterior",
                "numeroInterior",
            ];

            fieldsToSync.forEach((f) => {

                const fiscalField = "fiscal" + f.charAt(0).toUpperCase() + f.slice(1);
                const valueToSet = formValues[f] ?? "";
                dispatch(setFormValue({ field: fiscalField, value: valueToSet }));

                let isValid = false;

                if (f === "numeroExterior") {
                    isValid = valueToSet.trim() !== "";
                } else if (f === "numeroInterior") {
                    isValid = true; 
                } else {
                    isValid = valueToSet.trim() !== "";
                }

                dispatch(setValidValue({ field: fiscalField, isValid}));
            });
        }
        }, [ dispatch, formValues]);

    return (
        <Container maxWidth="md" disableGutters={{ xs: true, md: false }}>
            <FormSection>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12 }}>
                        <Typography
                            variant="body1"
                            sx={{
                                color: "text.secondary",
                                mt: 1,
                                mb: 1,
                                fontSize: "1rem",
                                fontWeight: "500",
                            }}
                        >
                            DOMICILIO PARTICULAR
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box
                            sx={{
                                minHeight: "3.5rem",
                                display: "flex",
                                alignItems: "flex-end",
                            }}
                            >
                        <Input
                            errorMessage="El código postal es un campo requerido"
                            label="Código Postal"
                            name="codigoPostal"
                            value={formValues.codigoPostal}
                            onChange={handleChange}
                            required
                            disabled
                            type="text"
                        />
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box
                            sx={{
                                minHeight: "3.5rem",
                                display: "flex",
                                alignItems: "flex-end",
                            }}
                            >
                        <Select
                            type="labeled"
                            label="Estado"
                            name="estadoRepublica"
                            value={estadoField.value}
                            onChange={estadoField.onChange}
                            onBlur={estadoField.onBlur}
                            options={[
                                { value: formValues.estadoRepublica, label: formValues.estadoRepublica },
                            ]}
                            errorMessage={estadoField.getErrorMessage()}
                            isInvalid={estadoField.isInvalid}
                            disabled
                            required
                        />
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box
                            sx={{
                                minHeight: "3.5rem",
                                display: "flex",
                                alignItems: "flex-end",
                            }}
                            >
                        <Select
                            type="labeled"
                            label="Municipio/Delegación"
                            name="alcaldiaMunicipio"
                            value={municipioField.value}
                            onChange={municipioField.onChange}
                            onBlur={municipioField.onBlur}
                            options={[
                              { value: formValues.alcaldiaMunicipio, label: formValues.alcaldiaMunicipio },
                            ]}
                            errorMessage={municipioField.getErrorMessage()}
                            isInvalid={municipioField.isInvalid}
                            disabled
                            required
                        />
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box
                            sx={{
                                minHeight: "3.5rem",
                                display: "flex",
                                alignItems: "flex-end",
                            }}
                            >
                        <Select
                            type="labeled"
                            label="Colonia o Fraccionamiento"
                            name="colonia"
                            value={coloniaField.value}
                            onChange={coloniaField.onChange}
                            onBlur={coloniaField.onBlur}
                            options={coloniasOptions}
                            errorMessage={coloniaField.getErrorMessage()}
                            isInvalid={coloniaField.isInvalid}
                            required
                        />
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <Box
                            sx={{
                                minHeight: "3.5rem",
                                display: "flex",
                                alignItems: "flex-end",
                            }}
                            >
                        <Input
                            label="Calle"
                            name="calle"
                            value={calleField.value}
                            onChange={calleField.onChange}
                            onBlur={calleField.onBlur}
                            errorMessage={calleField.getErrorMessage()}
                            isInvalid={calleField.isInvalid}
                            required
                            type="text"
                        />
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 6, md: 6 }} className="cp-input">
                        <Box
                            sx={{
                                minHeight: "3.5rem",
                                display: "flex",
                                alignItems: "flex-end",
                            }}
                            >
                        <Input
                            label="N° Ext"
                            name="numeroExterior"
                            value={numeroExteriorField.value}
                            onChange={numeroExteriorField.onChange}
                            onBlur={numeroExteriorField.onBlur}
                            errorMessage={numeroExteriorField.getErrorMessage()}
                            isInvalid={numeroExteriorField.isInvalid}
                            required
                            type="text"
                        />
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 6, md: 6 }} className="cp-input">
                        <Box
                            sx={{
                                minHeight: "3.5rem",
                                display: "flex",
                                alignItems: "flex-end",
                            }}
                            >
                        <Input
                            label="N° Int"
                            name="numeroInterior"
                            value={numeroInteriorField.value}
                            onChange={numeroInteriorField.onChange}
                            onBlur={numeroInteriorField.onBlur}
                            errorMessage={numeroInteriorField.getErrorMessage()}
                            isInvalid={numeroInteriorField.isInvalid}
                            type="text"
                        />
                        </Box>
                    </Grid>
                </Grid>
            </FormSection>
        </Container>
    );
};

export default ContractorAdress